var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('clinicList',{attrs:{"canEdit":true,"editRoute":"SuperAdminClinicEdit","canCreate":true,"createRoute":"SuperAdminClinicCreate","canViewDetail":true,"viewRoute":"SuperAdminClinicDetail","canViewClinicTreatmentHistory":true,"clinicTreatmentHistoryRoute":"SuperAdminClinicTreatmentHistory"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }